import React from 'react';
import { useSelector } from 'react-redux';
import YousignSignStep from './yousign/YousignSignStep';
import SignStep from './SignStep';

export default function SignStepStrategy(props) {
  const isMaster = useSelector((state) => state.currentServiceProvider.serviceProvider?.is_master);

  if (isMaster) {
    return <YousignSignStep {...props} />;
  }

  return <SignStep {...props} />;
}
